"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const WithSurveyContextHoc_1 = require("../hoc/WithSurveyContextHoc");
const ConfirmModal_1 = __importDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const Button = (props) => {
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const [wasMouseDowned, setWasMouseDowned] = (0, react_1.useState)(false);
    const [loadingState, setLoadingState] = (0, react_1.useState)(props.loadingState);
    const [modalIsOpened, setModalIsOpened] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        // wait for any field to blur (unfocus) and save and/or validate, then trigger click:
        if (props.widgetConfig.hideWhenRefreshing) {
            if (props.loadingState === 0 && loadingState > 0 && wasMouseDowned === true) {
                // this is a hack because it will ignore mouseup if triggered and
                // will run clickButton even if the mouse was not upped.
                // but there is no other way to wait for blur to complete with fast clicks
                // (fast clicks with onBlur do not trigger mouseup)
                setWasMouseDowned(false);
                onClickButton();
            }
        }
        setLoadingState(props.loadingState);
    }, [props.loadingState]);
    const startUpdateInterviewForButtonClick = react_1.default.useCallback((data, callback) => {
        // Set the button click user action to the startUpdateInterview call
        if (data.userAction === undefined) {
            data.userAction = {
                type: 'buttonClick',
                buttonId: props.path
            };
        }
        return props.startUpdateInterview(data, callback);
    }, [props.startUpdateInterview, props.path]);
    const startNavigateForButtonClick = react_1.default.useCallback((options, callback) => {
        const definedOptions = options || {};
        // Set the button click user action to the startNavigate call
        if (definedOptions.userAction === undefined) {
            definedOptions.userAction = {
                type: 'buttonClick',
                buttonId: props.path
            };
        }
        return props.startNavigate(definedOptions, callback);
    }, [props.startNavigate, props.path]);
    const onMouseDown = () => {
        setWasMouseDowned(true);
    };
    const onMouseUp = () => {
        if (!props.widgetConfig.hideWhenRefreshing) {
            onClickButton();
        }
        else {
            setWasMouseDowned(false);
            onClickButton();
        }
    };
    const confirmButton = () => {
        props.widgetConfig.action({
            // FIXME: setting the startUpdateInterview callback to the one
            // sending the user action will cause multiple calls to this
            // callback in the action to all send the userAction. If we move
            // the navigation and side effects to the server, it does not
            // matter, but a solution would need to be found if not.
            startUpdateInterview: startUpdateInterviewForButtonClick,
            startAddGroupedObjects: props.startAddGroupedObjects,
            startRemoveGroupedObjects: props.startRemoveGroupedObjects,
            startNavigate: startNavigateForButtonClick
        }, props.interview, props.path, props.section, props.surveyContext.sections, props.widgetConfig.saveCallback);
    };
    const onClickButton = () => {
        const hasConfirmPopup = props.widgetConfig.confirmPopup !== undefined;
        const confirmPopupConditional = hasConfirmPopup
            ? surveyHelper.parseBoolean(props.widgetConfig.confirmPopup.conditional, props.interview, props.path, props.user)
            : true;
        if (hasConfirmPopup && confirmPopupConditional === true) {
            setModalIsOpened(true);
        }
        else {
            confirmButton();
        }
    };
    const isLoading = props.widgetConfig.hideWhenRefreshing && props.loadingState > 0;
    const buttonColor = props.widgetConfig.color || 'green';
    if (!props.widgetStatus.isVisible) {
        return null;
    }
    return (react_1.default.createElement("div", { className: props.widgetConfig.align || 'center' },
        react_1.default.createElement("button", { type: "button", className: `survey-section__button button ${buttonColor} ${props.widgetConfig.size || 'large'} ${isLoading ? 'disabled' : ''}`, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onKeyUp: (e) => {
                if (e.key === 'enter' || e.key === 'space' || e.keyCode === 13 || e.keyCode === 32) {
                    onClickButton();
                }
                else {
                    return;
                }
            }, disabled: isLoading },
            props.widgetConfig.icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.widgetConfig.icon, className: "faIconLeft" }),
            surveyHelper.translateString(props.label || props.widgetConfig.label, i18n, props.interview, props.path)),
        modalIsOpened && props.widgetConfig.confirmPopup && (react_1.default.createElement("div", null,
            react_1.default.createElement(ConfirmModal_1.default, { isOpen: true, closeModal: () => setModalIsOpened(false), text: surveyHelper.translateString(props.widgetConfig.confirmPopup.content, i18n, props.interview, props.path), title: surveyHelper.translateString(props.widgetConfig.confirmPopup.title, i18n, props.interview, props.path) || '', cancelAction: props.widgetConfig.confirmPopup.cancelAction, showCancelButton: props.widgetConfig.confirmPopup.showCancelButton !== false, showConfirmButton: props.widgetConfig.confirmPopup.showConfirmButton !== false, cancelButtonLabel: surveyHelper.translateString(props.widgetConfig.confirmPopup.cancelButtonLabel, i18n, props.interview, props.path), confirmButtonLabel: surveyHelper.translateString(props.widgetConfig.confirmPopup.confirmButtonLabel, i18n, props.interview, props.path), cancelButtonColor: props.widgetConfig.confirmPopup.cancelButtonColor, confirmButtonColor: props.widgetConfig.confirmPopup.confirmButtonColor, containsHtml: props.widgetConfig.containsHtml || false, confirmAction: confirmButton })))));
};
exports.default = (0, WithSurveyContextHoc_1.withSurveyContext)(Button);
//# sourceMappingURL=Button.js.map